
export default function syncProperty (propertyName, localName) {
  const computed = {}
  computed[localName] = {
    get: function () {
      return this[propertyName]
    },
    set: function (value) {
      this.$emit(`update:${propertyName}`, value)
    }
  }

  return {
    props: [
      propertyName
    ],
    computed: computed
  }
}
